import { MessageOutlined } from '@ant-design/icons';
import { useDecaf } from '@decafhub/decaf-react';
import { Button, Grid, theme } from 'antd';
import React, { useEffect, useState } from 'react';

const ZENDESK_WIDGET_SCRIPT = 'https://static.zdassets.com/ekr/snippet.js';

declare global {
  interface Window {
    zE: any;
    zESettings: any;
  }
}

export default function ZendeskWidget() {
  const { me, publicConfig } = useDecaf();
  const [open, setOpen] = useState(false);
  const { token } = theme.useToken();
  const breakpoints = Grid.useBreakpoint();

  useEffect(() => {
    if (!publicConfig.zendesk || typeof document === 'undefined') return;
    const script = document.createElement('script');
    script.src = ZENDESK_WIDGET_SCRIPT + '?key=' + publicConfig.zendesk;
    script.async = true;
    script.id = 'ze-snippet'; // do not change this. zendesk expects this to be ze-snippet
    script.onload = () => {
      window.zE('webWidget', 'hide');
      window.zE('webWidget:on', 'open', () => {
        window.zE('webWidget', 'show');
        setOpen(true);
      });
      window.zE('webWidget:on', 'close', () => {
        window.zE('webWidget', 'hide');
        setOpen(false);
      });
    };

    document.body.appendChild(script);
    window.zESettings = {
      webWidget: {
        offset: {
          horizontal: -7,
          vertical: 20,
        },
      },
      contactForm: {
        subject: true,
        fields: [
          {
            id: 'name',
            prefill: { '*': me.fullname },
          },
          {
            id: 'email',
            prefill: { '*': me.email },
          },
        ],
      },
    };

    return () => {
      document.body.removeChild(script);
    };
  }, [publicConfig, me]);

  function toggle() {
    if (open) {
      window.zE?.('webWidget', 'close');
    } else {
      window.zE?.('webWidget', 'open');
    }
    setOpen(!open);
  }

  if (!publicConfig.zendesk) return null;

  return (
    <Button type="link" icon={<MessageOutlined />} style={{ backgroundColor: token.colorBgElevated }} onClick={toggle}>
      {!breakpoints.xs && 'Support'}
    </Button>
  );
}
